/* An ordered gangsheet (0.3e Stage B): once its print files were delivered to an order it can't change.
   It opens here, read-only: the sheets as they were ordered, and Edit a copy for a new draft. */

import { useState } from 'react';
import { formatDims, sheetStats } from '@gsb/core';
import { useStore, editCopy, emailOn } from '../store/store';
import { navigate } from '../router';
import { SheetThumb } from '../canvas/SheetThumb';
import { Icon } from '../ui/icons';
import { RemoveDialog } from '../ui/Email';

export function OrderedView() {
  const doc = useStore(s => s.doc);
  const meta = useStore(s => s.meta);
  const pid = useStore(s => s.projectId);
  const [remove, setRemove] = useState(false);
  const when = meta.orderedAt ? new Date(meta.orderedAt).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' }) : null;
  const all = doc.sheets.map(sheetStats);
  const transfers = all.reduce((n, s) => n + s.count, 0);
  const unit = doc.settings.unit === 'mm' ? 'cm' : doc.settings.unit;
  const counts = new Map<string, number>();
  doc.sheets.forEach(sh => sh.items.forEach(it => counts.set(it.designId, (counts.get(it.designId) || 0) + 1)));
  return (
    <main className="mine ordered">
      <div className="mine-in">
        <div className="mine-head">
          <div className="grow">
            <span className="kicker">Ordered gangsheet</span>
            <h1 className="h1">{doc.name || 'Your gangsheet'}</h1>
            <p className="small muted">
              <span className={'tchip t-' + doc.transfer}>{doc.transfer === 'uv' ? 'UV DTF' : 'DTF'}</span>{' '}
              {doc.sheets.length} sheet{doc.sheets.length === 1 ? '' : 's'} · {transfers} transfer{transfers === 1 ? '' : 's'}
            </p>
          </div>
          <div className="mine-head-acts">
            <button className="btn btn-line" onClick={() => navigate('/my')}><Icon name="sheets" />My gang sheets</button>
            <button className="btn btn-primary" onClick={() => pid && void editCopy(pid)} data-ordered="copy"><Icon name="copy" />Edit a copy</button>
          </div>
        </div>
        <p className="callout callout-info ord-note" role="status">
          <Icon name="info" />
          <span>{when ? 'Ordered on ' + when + (meta.orderRef ? ' (order ' + meta.orderRef + ')' : '') + '. ' : ''}This gangsheet is part of an order, so it can’t be changed. <b>Edit a copy</b> makes a new gangsheet from it, with the same artwork, to change or order again.</span>
        </p>
        <ul className="ord-sheets">
          {doc.sheets.map((s, i) => (
            <li key={s.id} className="card">
              <SheetThumb sheet={s} width={240} maxHeight={360} />
              <b>Sheet {i + 1}</b>
              <span className="small muted num">{formatDims(s.widthMm, s.lengthMm, unit)} · {s.items.length} transfer{s.items.length === 1 ? '' : 's'}</span>
            </li>
          ))}
        </ul>
        <section className="card ord-designs">
          <h2 className="h3">Designs</h2>
          <ul>
            {doc.designs.filter(d => counts.get(d.id)).map(d => (
              <li key={d.id}><span className="mname">{d.name}</span><span className="small muted num">{formatDims(d.widthMm, d.heightMm, unit)} × {counts.get(d.id)}</span></li>
            ))}
          </ul>
        </section>
        {emailOn() && meta.savedTo && (
          <p className="tiny muted ord-email"><Icon name="mail" />Saved to {meta.savedTo}. <button className="link small" onClick={() => setRemove(true)}>Remove from my email</button> (the order isn’t affected)</p>
        )}
      </div>
      {remove && pid && <RemoveDialog id={pid} name={doc.name} madeHere={meta.madeHere} savedTo={meta.savedTo!} onClose={() => setRemove(false)} />}
    </main>
  );
}
